module.exports = __webpack_public_path__ + "images/McPay.82d0140af236865eea0ee770ec964364.svg";